import type { FaireProductEntity } from "../../entity_types/product";

export const p_jz35k3fsam: FaireProductEntity = {
  token: "p_jz35k3fsam",
  type: "product",
  name: "The Farmer Who Chose to Plant Kindness",
  brandToken: "b_4q06brhpm1",
  brandName: "Harvest House Publishers Gift & Specialty Books",
  imageUrl:
    "https://cdn.faire.com/fastly/26750f11115e05ffaee0e51caae942a51f49dd616f26a8b342084490c9e9f81f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/12f3cccbd17ccf6a745ae0012bb26dc158d14022cc238887b91ce8b5a0fd9465.jpeg",
    "https://cdn.faire.com/fastly/a86147368c79d2d5ac06d319e64fc4e8b5ad6a32ee393b9e0610da784eb118d1.jpeg",
    "https://cdn.faire.com/fastly/bf4253be97258f858464930607fd2f898a48809bf58fecb3472d98d36ca15a92.jpeg",
    "https://cdn.faire.com/fastly/9343b66f2b08ff34ed39453404bc53c7bd9219898cd4fd6f51edaa7778cff7bd.jpeg",
    "https://cdn.faire.com/fastly/ffbbef63d60398faca2754e6fb8218013b02d10c60d6d08e56721c3666c16327.jpeg",
    "https://cdn.faire.com/fastly/c7872a8c3e143a254366cbdd8315dade6bfa4e43b7ea752254f34c1dc6e2a0b5.jpeg",
    "https://cdn.faire.com/fastly/f15b46384e9eeb5d69a675faeb0678cfeffdf8d5c2864a1e4ac0e2b5d13d0732.jpeg",
    "https://cdn.faire.com/fastly/e7a044d6a1df04ea5f57608d8b4eb542dd99eeb3fe78540f917f72796888498f.jpeg",
    "https://cdn.faire.com/fastly/eca58001f54826f11fffe305f63c2fe1a688ef3b3fff36bcb26f576a7f101a5e.jpeg",
  ],
  priceDollars: 13.15,
  description:
    "Buy 6 of any title and get the 7th free!\n\nThis biblically based fable teaches children the consequences of selfishness and how genuine, Christlike kindness can be contagious.   \n \nHadley the farmer is the nicest guy in the land of Thad. He’s always helping his neighbors or giving to the poor, until one day a seed of selfishness takes root in Hadley’s heart. Suddenly, the once-friendly farmer turns fiendish—and to make things worse, his sinful attitude is “reaping” havoc all over town. Can a chance encounter with one of Thad’s littlest residents help restore the farmer’s kindness?\n \nBased on teachings from the book of Ephesians, The Farmer Who Chose to Plant Kindness helps children see how their choices and attitudes influence others, what to do when they sin, and most important, how to sow kindness wherever they go.",
  tags: [],
  msrpDollars: 26.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:48.055Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
